import jrSortFiltersTemplate from '../../../view/angular/serp/sort-filters.tpl.html';
import jrNewAllFiltersTemplate from '../../../view/angular/serp/new-all-filters.tpl.html';
import { JtagService } from '../../../ts/service/jtag-service.ts';

angular
  .module('jrSerpDirective', ['jrSerpService', 'jrConfig'])
  .directive('jrSortFilters', jrSortFilters)
  .directive('jrNewAllFilters', jrNewAllFilters);

jrSortFilters.$inject = [
  'SearchUrlService',
  'FiltersUrlService',
  'Messages',
  'SearchConfig',
  '$window',
];
jrNewAllFilters.$inject = ['SearchConfig', 'FiltersUrlService', 'Messages', '$window', 'isMobile'];

function jrSortFilters(SearchUrlService, FiltersUrlService, Messages, SearchConfig, $window) {
  return {
    restrict: 'A',
    template: jrSortFiltersTemplate,
    link(scope, elem, attrs) {
      scope.sortFilters = [
        {
          label: Messages.SortFilterByRelevance,
          active: !!(
            SearchUrlService.getURLParameter('sortby') === 'relevance' ||
            !SearchUrlService.getURLParameter('sortby')
          ),
          url: FiltersUrlService.getFilterUrl('sortby', 'relevance'),
          type: 'relevance',
        },
        {
          label: Messages.SortFilterByDate,
          active: SearchUrlService.getURLParameter('sortby') === 'publish_date',
          url: FiltersUrlService.getFilterUrl('sortby', 'publish_date'),
          type: 'publish_date',
        },
      ];

      scope.sortFilterClick = function (event, label) {
        event.preventDefault();

        JtagService.trackCustomEvent('click_sortby', {
          event_label: `${label}_filter`,
        });

        $window.location.href = event.target.href;
      };

      JtagService.trackCustomEvent('impression_sortby', {
        event_label: SearchConfig.sortBy === '' ? 'relevance' : SearchConfig.sortBy,
      });
    },
  };
}

function jrNewAllFilters(SearchConfig, FiltersUrlService, Messages, $window, isMobile) {
  return {
    restrict: 'A',
    template: jrNewAllFiltersTemplate,
    link(scope, elem, attrs) {
      scope.newAllTitle = Messages.AllJobsFiltersTitle;
      scope.newAllFilters = [
        {
          label: labelComposer(
            isMobile ? Messages.AllJobsNavigationFilterMobile : Messages.AllJobsNavigationFilter,
            'all',
            SearchConfig.isTabsJobsCountEnabled
          ),
          activeLabel: labelComposer(
            isMobile
              ? Messages.AllJobsNavigationFilterActiveMobile
              : Messages.AllJobsNavigationFilterActive,
            'all',
            SearchConfig.isTabsJobsCountEnabled
          ),
          active: SearchConfig.showMode === 'all',
          url: FiltersUrlService.getFilterUrl('shm', 'all'),
          type: 'all',
        },
        {
          label: labelComposer(
            isMobile ? Messages.NewJobsNavigationFilterMobile : Messages.NewJobsNavigationFilter,
            'new',
            SearchConfig.isTabsJobsCountEnabled
          ),
          activeLabel: labelComposer(
            isMobile
              ? Messages.NewJobsNavigationFilterActiveMobile
              : Messages.NewJobsNavigationFilterActive,
            'new',
            SearchConfig.isTabsJobsCountEnabled
          ),
          active: SearchConfig.showMode === 'new',
          url: FiltersUrlService.getFilterUrl('shm', 'new'),
          type: 'new',
        },
      ];
      scope.filterClick = function (event, label) {
        event.preventDefault();

        JtagService.trackCustomEvent('click_filter', {
          event_label: `${label}_filter`,
        });

        $window.location.href = event.target.href;
      };

      JtagService.trackCustomEvent('impression_filter', {
        event_label: SearchConfig.showMode,
      });

      function labelComposer(message, type, tabsJobsCountEnabled) {
        return tabsJobsCountEnabled
          ? `${message} (${SearchConfig.showModeCounters[type]})`
          : message;
      }
    },
  };
}
